var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "head" }, [
        _c("div", [
          _c("img", {
            staticClass: "logo",
            attrs: { src: require("../../assets/img/logo-shopvidi-new.png") },
            on: {
              click: function($event) {
                return _vm.$router.push({ path: "Order" })
              }
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content1-right-personimg" },
          [
            _c(
              "el-dropdown",
              { attrs: { size: "medium" } },
              [
                _c(
                  "span",
                  {
                    staticClass: "el-dropdown-link",
                    staticStyle: {
                      cursor: "pointer",
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "center"
                    }
                  },
                  [
                    _c("div", { staticClass: "user-icon" }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/img/use.png"),
                          width: "17px",
                          height: "17px"
                        }
                      })
                    ]),
                    _c(
                      "span",
                      {
                        staticStyle: { height: "17px", "height-line": "17px" }
                      },
                      [_vm._v(_vm._s(_vm.showUsername))]
                    ),
                    _c("i", {
                      staticClass: "el-icon-arrow-down el-icon--right"
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-dropdown-menu",
                  { attrs: { slot: "dropdown" }, slot: "dropdown" },
                  [
                    _c(
                      "el-dropdown-item",
                      {
                        nativeOn: {
                          click: function($event) {
                            return _vm.signOut.apply(null, arguments)
                          }
                        }
                      },
                      [_vm._v("Sign Out")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "el-aside",
        { staticClass: "aside" },
        [
          _c("left-menu", {
            attrs: {
              checkedMenu: _vm.checkedMenu,
              firstMenuName: _vm.firstMenuName,
              menuList: _vm.menuList
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-container",
        { staticClass: "menu-content-main" },
        [
          _c(
            "el-main",
            { staticClass: "main-container" },
            [
              this.$route.params.key === "Order"
                ? _c("order", { ref: "Order" })
                : this.$route.params.key === "creatOrder"
                ? _c("creatOrder", { ref: "creatOrder" })
                : this.$route.params.key === "store-review"
                ? _c("StoreReview", { ref: "storeReview" })
                : this.$route.params.key === "editOrder"
                ? _c("editOrder", { ref: "editOrder" })
                : this.$route.params.key === "shipping"
                ? _c("ShippingDetail", { ref: "shipping" })
                : this.$route.params.key === "shipping-invoice"
                ? _c("ShippingInvoice", { ref: "shipping-invoice" })
                : this.$route.params.key === "business-info"
                ? _c("update-business", { ref: "business-info" })
                : this.$route.params.key === "Brands"
                ? _c("brands", { ref: "brands" })
                : this.$route.params.key === "Products"
                ? _c("produts", { ref: "updateBusiness" })
                : this.$route.params.key === "Wallet"
                ? _c("wallet", { ref: "Wallet" })
                : this.$route.params.key === "spuDetails"
                ? _c("spu-details", { ref: "spuDetails" })
                : this.$route.params.key === "wholesale-spu-detail"
                ? _c("wholesale-spu-detail", { ref: "wholesale-spu-detail" })
                : this.$route.params.key === "OrderDetail"
                ? _c("order-detail", { ref: "OrderDetail" })
                : this.$route.params.key === "images"
                ? _c("images-list", { ref: "imagesList" })
                : this.$route.params.key === "service-order"
                ? _c("service-order-list", { ref: "service-order" })
                : this.$route.params.key === "service-order-detail"
                ? _c("service-order-detail", { ref: "service-order-detail" })
                : this.$route.params.key === "refer-orders"
                ? _c("refer-orders", { ref: "refer-orders" })
                : this.$route.params.key === "create-refer-orders"
                ? _c("create-refer-order", { ref: "create-refer-orders" })
                : this.$route.params.key === "wholesale-create-refer-orders"
                ? _c("wholesale-create-refer-order", {
                    ref: "wholesale-create-refer-orders"
                  })
                : this.$route.params.key === "refer-orders-detail"
                ? _c("refer-orders-detail", { ref: "refer-orders-detail" })
                : this.$route.params.key === "procurement-orders"
                ? _c("procurement-orders", { ref: "procurement-orders" })
                : this.$route.params.key === "procurement-products"
                ? _c("procurement-products", { ref: "procurement-products" })
                : this.$route.params.key === "procurement-orders-create"
                ? _c("procurement-orders-create")
                : this.$route.params.key === "procurement-orders-detail"
                ? _c("procurement-orders-detail")
                : this.$route.params.key === "edit-item-avaliability"
                ? _c("edit-item-avaliability", {
                    ref: "edit-item-avaliability"
                  })
                : this.$route.params.key === "logistics-detail"
                ? _c("logistic-detail", { ref: "logistics-detail" })
                : this.$route.params.key === "invoice" ||
                  this.$route.params.key === "procurement-orders-invoice"
                ? _c("invoice", { ref: "invoice" })
                : this.$route.params.key === "Customers"
                ? _c("customer", { ref: "Customers" })
                : this.$route.params.key === "CustomersDetail"
                ? _c("customersDetail", { ref: "CustomersDetail" })
                : this.$route.params.key === "sku-inventory" ||
                  this.$route.params.key === "procurement-sku-inventory"
                ? _c("sku-inventory")
                : this.$route.params.key === "CreateSpu"
                ? _c("create-spu", { ref: "createSpu" })
                : this.$route.params.key === "Opportunities"
                ? _c("opportunities", { ref: "Opportunities" })
                : this.$route.params.key === "opportunitiesDetail"
                ? _c("opportunitiesDetail", { ref: "opportunitiesDetail" })
                : this.$route.params.key === "home"
                ? _c("brand-home")
                : this.$route.params.key === "Explore"
                ? _c("ExploreParent", { ref: "explore" })
                : this.$route.params.key === "store-based-marketing"
                ? _c("StoreBasedMarketingList", { ref: "storeBasedMarketing" })
                : this.$route.params.key === "create-store-based-marketing"
                ? _c("StoreBasedMarketingCreate", {
                    ref: "createStoreBasedMarketing"
                  })
                : this.$route.params.key === "store-based-marketing-detail"
                ? _c("StoreBasedMarketingDetail", {
                    ref: "detailStoreBasedMarketing"
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-602ccd29", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-602ccd29","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/menu-index.vue
// module id = uyyu
// module chunks = 2